
import { Options, Vue } from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import CardRh from "@/components/cards/ManzaCard.vue";
import KDataTable from "@/components/datatable/newdatatable.vue";
import ImpedimentoInstrutorService from "@/service/v1/sigap/ImpedimentoInstrutorService";

@Options({
    name: "QtsSemanalImpedimentosView",
    components: { CardRh, KDataTable },
})
export default class QtsSemanalImpedimentosView extends Vue {

    @Prop() readonly perfis!: any
    @Prop() readonly model!: any

    public service = new ImpedimentoInstrutorService();
    public processando = false;
    public reloadDatatable = false;
    public config: any = null;

    private fmtData(v: any) {
        if (!v) return '';
        const s = String(v).substring(0, 10);
        const p = s.split('-');
        return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : s;
    }

    private fmtHora(v: any) {
        return v ? String(v).substring(0, 5) : '';
    }

    private fmtCpf(v: any) {
        if (!v) return '';
        const s = String(v).replace(/\D/g, '');
        return s.length === 11
            ? s.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
            : v;
    }

    created() {
        const dataMin = this.model?.inicio ? String(this.model.inicio).substring(0, 10) : null;
        const dataMax = this.model?.fim    ? String(this.model.fim).substring(0, 10)    : null;

        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d: any) => ({
                Skip: d.start,
                Take: d.length,
                search: d.search.value,
                dataMin,
                dataMax,
            }),
        };
        this.config.order = [[2, 'asc'], [0, 'asc']];
        this.config.columns = [
            { data: 'professor.nome',  name: 'professor.nome' },
            { data: 'professorCpf',    name: 'professorCpf',  orderable: false, searchable: false, class: 'text-center' },
            { data: 'data',            name: 'data',           class: 'text-center' },
            { data: 'inicio',          name: 'inicio',         orderable: false, searchable: false, class: 'text-center' },
            { data: 'fim',             name: 'fim',            orderable: false, searchable: false, class: 'text-center' },
        ];
        this.config.columnDefs = [
            { targets: 1, render: (v: any) => this.fmtCpf(v) },
            { targets: 2, render: (v: any) => this.fmtData(v) },
            { targets: 3, render: (v: any) => this.fmtHora(v) },
            { targets: 4, render: (v: any) => this.fmtHora(v) },
        ];
    }

    public tableatualizada() {
        // sem ações inline
    }
}
